module.exports = __webpack_public_path__ + "img/temp_serve.9a70af7f.png";